import { render, staticRenderFns } from "./PaymentCancellation.vue?vue&type=template&id=5e4b88d0&scoped=true"
import script from "./PaymentCancellation.vue?vue&type=script&lang=js"
export * from "./PaymentCancellation.vue?vue&type=script&lang=js"
import style0 from "./PaymentCancellation.vue?vue&type=style&index=0&id=5e4b88d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4b88d0",
  null
  
)

export default component.exports